import { Stack, Typography, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { SETTINGS_BASE_PATH } from '../const';

type SettingsContentHeaderProps = {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionLoading?: boolean;
};

export const SettingsContentHeader = ({
  title,
  subtitle,
  actionLabel,
  onAction,
  actionLoading
}: SettingsContentHeaderProps) => {
  const navigate = useNavigate();

  return (
    <HeaderRow>
      <Stack gap={0.75}>
        <PageTitle>{title}</PageTitle>
        {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
      </Stack>

      <Stack alignItems="flex-end" gap={1}>
        {actionLabel && onAction && (
          <ButtonCustom
            label={actionLoading ? 'Saving...' : actionLabel}
            disabled={actionLoading}
            onClick={onAction}
            style={{
              width: 'auto',
              minWidth: 168,
              height: 46,
              paddingLeft: 22,
              paddingRight: 22,
              borderRadius: 7
            }}
          />
        )}
        <BackLink onClick={() => navigate(SETTINGS_BASE_PATH)}>Back to Settings</BackLink>
      </Stack>
    </HeaderRow>
  );
};

const HeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 24,
  marginBottom: 26,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

const PageTitle = styled(Typography)(() => ({
  color: '#071E42',
  fontSize: 26,
  lineHeight: 1.25,
  fontWeight: 700
}));

const PageSubtitle = styled(Typography)(() => ({
  color: '#53627A',
  fontSize: 15,
  lineHeight: 1.6
}));

const BackLink = styled(Typography)(() => ({
  color: '#1769C2',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' }
}));
